import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { WelcomeVideosInitialType } from '../utils/Types';
import { isAPISuccess } from '../utils/Util';
import {
  welcomeVideosGetAllList,
  welcomeVideosAddMedia,
  welcomeVideosRemoveMedia,
} from '../services';
import { API_STATUS } from '../utils/Constant';

const initialState: WelcomeVideosInitialType = {
  videos: [],
  status: '',
};

export const getWelcomeVideosList = createAsyncThunk(
  'welcomeVideos/getWelcomeVideosList',
  async () => {
    const res = await welcomeVideosGetAllList();
    return res.data;
  }
);

export const uploadMedia = createAsyncThunk<any, any>(
  'wlcomeVideos/UploadMedia',
  async (data: any) => {
    const res = await welcomeVideosAddMedia(data);
    return res.data;
  }
);

export const removeMedia = createAsyncThunk<any, any>(
  'welcomeVideos/removeMedia',
  async (param: any) => {
    const res = await welcomeVideosRemoveMedia(param);
    return res.data;
  }
);

export const welcomeVideosSlice = createSlice({
  name: 'welcomeVideos',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getWelcomeVideosList.pending, (state) => {
        state.status = API_STATUS.LOADING;
      })
      .addCase(getWelcomeVideosList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.videos = action.payload.result ?? [];
          state.status = API_STATUS.SUCCEEDED;
        } else {
          state.videos = [];
          state.status = API_STATUS.FAILED;
        }
      });
  },
});

export const welcomeVideosSelector = (state: {
  welcomeVideos: WelcomeVideosInitialType;
}) => state.welcomeVideos;

export default welcomeVideosSlice.reducer;
